import React from "react";
import { Badge } from "../ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { FormActions } from "../app";
import {
  InvoiceDateFields,
  InvoiceEntityFields,
  InvoiceItemsEditor,
  InvoiceNotesField,
  InvoiceStatusFields,
} from "./InvoiceFormSections";

export function InvoiceEditDialog({
  open,
  onOpenChange,
  editingInvoice,
  formData,
  setFormData,
  clients,
  projects,
  t,
  isEditDraft,
  onSubmit,
  onCancel,
  onAddItem,
  onUpdateItem,
  onRemoveItem,
  onTaxRateChange,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto border-[#242E42] bg-[#151B26]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-['Outfit'] text-[#F3F4F6]">
            Edit Invoice {editingInvoice?.invoice_number}
            {!isEditDraft && (
              <Badge className="border-amber-500/30 bg-amber-500/20 text-xs text-amber-400">
                Read-only content
              </Badge>
            )}
          </DialogTitle>
        </DialogHeader>

        {!isEditDraft && (
          <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-3 text-sm text-amber-400">
            This invoice is in <strong>{editingInvoice?.status}</strong> status.
            Only status, paid date, and notes can be modified. Content fields
            are locked to protect financial data integrity.
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <InvoiceStatusFields formData={formData} setFormData={setFormData} t={t} />

          <InvoiceEntityFields
            formData={formData}
            setFormData={setFormData}
            clients={clients}
            projects={projects}
            t={t}
            disabled={!isEditDraft}
            showLocks
          />

          <InvoiceDateFields
            formData={formData}
            setFormData={setFormData}
            t={t}
            disabled={!isEditDraft}
            showLocks
          />

          <InvoiceItemsEditor
            formData={formData}
            t={t}
            onAddItem={onAddItem}
            onUpdateItem={onUpdateItem}
            onRemoveItem={onRemoveItem}
            onTaxRateChange={onTaxRateChange}
            disabled={!isEditDraft}
            showLocks
          />

          <InvoiceNotesField formData={formData} setFormData={setFormData} t={t} />

          <FormActions
            cancelLabel={t("cancel")}
            submitLabel={t("save")}
            onCancel={onCancel}
          />
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default InvoiceEditDialog;
